export default __webpack_public_path__ + "static/media/560.c85eaff0.png";